import React from 'react';
import { useParams } from 'react-router-dom';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';
import LanguageUpdateForm from '../../components/forms/LanguageUpdateForm/LanguageUpdateForm';

const LangUpdate = () => {

  const { uid, language } = useParams();

  return (
    <AuthLayout pageName="lang-update">
      <LanguageUpdateForm userId={uid} lang={language} />
    </AuthLayout>
  );
};

export default LangUpdate;
